import React,{Component} from 'react';
import {Router, Route, Switch} from 'react-router-dom';

import { AuthSalesUser } from '../components/salesUser/common/AuthGuard';
import SalesLoginComp from '../components/salesUser/login/Login';
import CampaignListComp from '../components/salesUser/campaign/CampaignListComp';
import EditKycDetailComp from '../components/salesUser/campaign/EditKycDetails';
import ViewCampaign from '../components/salesUser/campaign/ViewCampaign';
import Loader from '../components/common/Loader';
import Error from '../components/admin/common/Error';
import { history } from '../history/history';

import '../../assets/css/style.scss';
import incentivedetails from '../components/salesUser/campaign/incentivedetails';
import payoutdetails from '../components/salesUser/campaign/payoutdetails';
import DsaIncenticeTermsandCond from "../components/salesUser/campaign/tersandcondpage"
import invoicedetails from '../components/salesUser/campaign/invoicedetails';
import contactdetails from '../components/salesUser/campaign/contactdetails';
import coupons from '../components/salesUser/campaign/coupons';
import nonfctcodes from '../components/salesUser/campaign/nonfctcode';

class SalesUserRoutes extends Component {
  constructor(props) {
    super(props);
  }

  //Define Sales User Route
  render() { 
    const { match } = this.props;
    return (
      <Router history= {history}>
        <div className="user">
          <Loader/>
          <Error />
          <Switch>
            <Route  path={`${match.url}/login`} component={SalesLoginComp} /> 
            <AuthSalesUser path={`${match.url}/campaign`} component={CampaignListComp} />
            <AuthSalesUser path={`${match.url}/viewcampaign`} component={ViewCampaign} />
            <AuthSalesUser path={`${match.url}/EditKycDetails`} component={EditKycDetailComp} />
          <AuthSalesUser path={`${match.url}/incentivedetails`} component={incentivedetails} />
          <AuthSalesUser path={`${match.url}/invoicedetails`} component={invoicedetails} />
          <AuthSalesUser path={`${match.url}/payouts`} component={payoutdetails} />
          <AuthSalesUser path={`${match.url}/terms`} component={DsaIncenticeTermsandCond} />
          <AuthSalesUser path={`${match.url}/contact`} component={contactdetails} />
          <AuthSalesUser path={`${match.url}/coupons`} component={coupons} />
          <AuthSalesUser path={`${match.url}/nonfctcodes`} component={nonfctcodes} />

          </Switch>
        </div>
      </Router>
    )
  }
}
export default SalesUserRoutes;


// WEBPACK FOOTER //
// ./web/routes/salesUserRoute.js